{
  "quoteStale": {
    "title": "Price updated",
    "regionLabel": "Price updated — confirmation required",
    "body": {
      "PRICE_CHANGED": "The product price changed since your quote. Review the new total before paying.",
      "SHIPPING_CHANGED": "The shipping cost changed since your quote. Review the new total before paying.",
      "TAX_CHANGED": "The tax changed since your quote. Review the new total before paying.",
      "EXPIRED": "Your quote expired. Review the new total before paying.",
      "CART_CHANGED": "Your order changed since your quote. Review the new total before paying.",
      "CONSUMED": "This quote has already been paid.",
      "MISSING_SNAPSHOT": "Your quote is no longer valid. Review the new total before paying.",
      "fallback": "The price changed since your quote. Review the new total before paying."
    },
    "reason": {
      "PRICE_CHANGED": "Product price changed",
      "SHIPPING_CHANGED": "Shipping cost changed",
      "TAX_CHANGED": "Tax changed",
      "EXPIRED": "Quote expired",
      "CART_CHANGED": "Order contents changed",
      "CONSUMED": "Already paid",
      "MISSING_SNAPSHOT": "Quote no longer valid"
    },
    "reviewCart": "Review cart",
    "confirmNewPrice": "Confirm new price {{total}}",
    "confirmNewPriceBusy": "Confirming…",
    "rejectedLinesNote": "Some items can no longer be priced. Review the cart before paying.",
    "requestId": "Support reference: {{id}}",
    "previousAmount": "Previous {{amount}}",
    "newAmount": "New {{amount}}"
  },
  "breakdown": {
    "subtotal": "Subtotal",
    "shipping": "Shipping",
    "shippingWithService": "Shipping ({{service}})",
    "tax": "Tax",
    "taxWithRate": "Tax ({{rate}}%)",
    "total": "Total",
    "changedRow": "Changed"
  },
  "shippingUnavailable": {
    "regionLabel": "Shipping unavailable — payment blocked",
    "title": "Shipping unavailable",
    "body": "No shipping service covers this destination. Change the delivery address to continue.",
    "changeAddress": "Change address",
    "payDisabled": "Pay"
  },
  "checkout": {
    "totalPending": "Working out the latest price…",
    "totalUnavailable": "No price yet",
    "totalAnnounced": "Total updated: {{total}}",
    "payCta": "Pay {{total}}",
    "payCtaNoTotal": "Pay",
    "payBusy": "Processing…",
    "payBlocked": {
      "EMPTY_CART": "Add at least one item before paying.",
      "PREVIEW_LOADING": "Waiting for the latest price…",
      "PREVIEW_ERROR": "We couldn't get an up-to-date price. Retry before paying.",
      "CART_DIRTY": "Your order changed — waiting for the new price.",
      "NO_QUOTE": "No price has been calculated for this order yet.",
      "QUOTE_EXPIRED": "This price has expired. It will refresh in a moment.",
      "REJECTED_LINES": "Some items can't be priced. Review the cart before paying."
    },
    "previewFailedTitle": "Price unavailable",
    "previewFailedBody": "We couldn't get an up-to-date price for this order. Retry to continue.",
    "retry": "Retry",
    "walletShortfall": "Your wallet is {{shortfall}} short. Top it up and try again.",
    "rejectedLinesTitle": "These items can't be priced",
    "rejectedLine": "{{variant}} — {{reason}}",
    "rejectedReason": {
      "VARIANT_NOT_FOUND": "Variant no longer exists",
      "BLUEPRINT_NOT_FOUND": "Product no longer exists",
      "PRODUCT_NOT_SELLABLE": "This product is not on sale yet",
      "UNPRICED_VARIANT": "No price set for this variant",
      "INACTIVE_VARIANT": "Variant is no longer available"
    },
    "toast": {
      "orderConfirmed": "Order paid",
      "orderConfirmedDetail": "{{total}} charged to your {{source}}.",
      "fundingSource": {
        "wallet": "wallet",
        "credit": "credit line"
      },
      "confirmInvalid": "We couldn't submit this payment — check the order and try again.",
      "walletInsufficient": "Not enough balance to pay this order.",
      "orderForbidden": "You don't have access to this order.",
      "orderNotFound": "This order no longer exists.",
      "sessionExpired": "Your session expired — please sign in again.",
      "rateLimited": "Too many requests. Try again in {{seconds}} seconds.",
      "alreadyPaid": "This order has already been paid.",
      "keyReuse": "That payment attempt is no longer valid — refresh and try again.",
      "confirmFailed": "Payment failed. Please try again."
    }
  },
  "_vgBinding": "vg-binding: P4.12.D-17 · vg-binding: P4.12.D-20 · vg-binding: P4.12.D-22 · vg-binding: INTERFACE-STANDARDS:error-shape — QuoteStaleBanner copy: re-consent title/body per QUOTE_STALE reason, reason LABELS (wire enum VALUE stays English), delta-table row labels and the SHIPPING_UNAVAILABLE variant. en/vi/fr, equal key counts [task-16] · [task-15] vg-binding: P4.12.D-19 · vg-binding: P4.12.D-21 · vg-binding: P4.12.D-33 · vg-binding: P4.12.D-35 · vg-binding: INTERFACE-STANDARDS:error-shape — adds the `checkout.*` block: breakdown skeleton/empty labels, the D-21 PayButton CTA + per-reason blocked labels (wire enum VALUE stays English), the rejected-line reasons, the wallet-shortfall notice and the confirm toast catalog (API-CONTRACTS/post-orders-id-confirm.md BLOCK 5 toast_text). en/vi/fr, equal key counts"
}
